var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationFillTrue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Fill=True"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.19 3.00001C7.92 3.43001 5.76 6.52001 5.96 9.80001C6.27 14.88 9.51 18.8 11.11 20.65C11.58 21.19 12.41 21.19 12.88 20.65C14.56 18.7 18.06 14.04 18.06 9.01001C18.06 5.40001 14.89 2.53001 11.19 3.00001ZM12 11.93C10.39 11.93 9.08 10.62 9.08 9.01001C9.08 7.40001 10.39 6.10001 12 6.10001C13.61 6.10001 14.91 7.41001 14.91 9.01001C14.91 10.61 13.61 11.93 12 11.93Z",
    fill: "#0C0C0C"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationFillTrue);
export default __webpack_public_path__ + "static/media/Location Fill=True.e7f85a34f372bd29059c757cd71e98f1.svg";
export { ForwardRef as ReactComponent };